'use strict';

function DashboardMortgage() {
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MortgageController, _ResponsiveLayout];
  this._$node = null;
  this._$sectionContainer = null;
  this._$rates = null;

  this.init = function () {
    this._super();

    this._portalPresenter = document.getElementById('Portal').mogo();

    var MEMBER_CONTENTS_KEY = 'mortgage-interstitial';
    // user must view interstitial content once before viewing this page
    if (!this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY)) {
      this.history.replaceUrl(Product.shortcutMappings[MEMBER_CONTENTS_KEY]);
      return;
    }
    this._$node = $(this.node);
    this._$sectionContainer = this._$node.find('.section-container');

    // picture element fix for injected html
    if (typeof picturefill === 'function') {
      picturefill();
    }
  };

  this.initAllReady = function () {
    this._super();

    this.registerResponsiveFunction($.proxy(this._restoreDefaultView, this), window.mogo.registry.mogoUI.config.mediaQueries.small + 1);
  };

  this.initPage = function () {
    var _this = this;

    // show tray-create-mortgage in tray for large and above
    var isLargeOrAbove = $(window).width() > window.mogo.registry.mogoUI.config.mediaQueries.medium;
    if (isLargeOrAbove && this._applicationStarted() && !this._applicationCompleted()) {
      this._history.replaceUrl('/member/dashboard/mortgage/in_progress');
    }

    if (this.presenter.models.mortgage.status === 'opened') {
      this._$sectionContainer.addClass('section-container--hidden'); // by default both sections are hidden
    }

    // event handlers
    this._$node.find('.js--live-chat-open').on('click', function () {
      if (window.LC_API && window.LC_API.open_chat_window) window.LC_API.open_chat_window();
    });
    this._$node.find('.processBtn').on('click', this._showProgressSteps.bind(this));
    this._$node.find('.psuedoBack').on('click', this._hideProgressSteps.bind(this));

    this.analytics.pushEvent('virtual-page-view');
    this.pushAnalyticsMortgageInfo(); // mortgage status analytics data

    // Dynamically create the rates comparison component so we can pass the presenter to the component
    this._$rates = this._$node.find('.js--mortgage-rates-comparison').each(function (i, el) {
      $(el).mogo().create('MortgageRatesComparison', {
        presenter: _this.presenter,
        onComplete: _this._redrawLegal.bind(_this)
      });
    });

    this._$node.find('.js--legal-disclaimer').mogo().create('LegalDisclaimer', {
      presenter: this.presenter,
      legal: $('[data-legal]:visible', this.node),
      otherLegal: ['disclaimer.mogoMortgageLicenses']
    });

    if (this.presenter.getModelProperty('mortgage_funded.mortgages[0].type') == 'fixed') {
      setTimeout(this._setupDials.bind(this)); // setup dials
    }

    this.presenter.addComputedVariable('currentYear', null, function () {
      return new Date().getFullYear();
    });
    this.presenter.addComputedVariable('currentTerm', ['mortgage_funded.mortgages[0].term_progress', 'mortgage_funded.mortgages[0].term_length'], function (progress, length) {
      return Math.ceil(length * (progress / 100)) || 1;
    });
    this.presenter.addComputedVariable('lastCompleteTerm', ['mortgage_funded.mortgages[0].term_progress', 'mortgage_funded.mortgages[0].term_length'], function (progress, length) {
      return Math.floor(length * (progress / 100));
    });

    this.presenter.addComputedVariable('amoritization_month', ['mortgage_funded.mortgages[0].interest_adjustment_date', 'mortgage_funded.mortgages[0].amortization_length'], function (date, years) {
      var endDate = new Date(date);
      endDate.setFullYear(endDate.getFullYear() + years);

      var result = endDate - new Date();
      var millisecondsDay = 86400000;
      var daysYear = 365;
      var daysMonth = 30;

      var remainder = result % (millisecondsDay * daysYear);
      var months = Math.floor(remainder / (millisecondsDay * daysMonth));

      return months;
    });
    this.presenter.addComputedVariable('amoritization_year', ['mortgage_funded.mortgages[0].interest_adjustment_date', 'mortgage_funded.mortgages[0].amortization_length'], function (date, years) {
      var endDate = new Date(date);
      endDate.setFullYear(endDate.getFullYear() + years);
      var result = endDate - new Date();
      var millisecondsDay = 86400000;
      var daysYear = 365;
      return Math.floor(result / (millisecondsDay * daysYear));
    });

    this.presenter.addComputedVariable('term_maturity_month', ['mortgage_funded.mortgages[0].term_maturity_date'], function (date) {
      return moment(date).format('MMM');
    });
    this.presenter.addComputedVariable('term_maturity_year', ['mortgage_funded.mortgages[0].term_maturity_date'], function (date) {
      return moment(date).format('YYYY');
    });
    this.presenter.addComputedVariable('principal_paid', ['mortgage_funded.mortgages[0].loan_amount', 'mortgage_funded.mortgages[0].principal_balance'], function (loanAmount, principalBalance) {
      return loanAmount - principalBalance;
    });

    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();
  };

  this._setupDials = function () {
    this._$node.find('.progress-details__dial').mogo().create('ThreePartDial', {
      type: 'percent-steps',
      steps: this.presenter.getModelProperty('mortgage_funded.mortgages[0].term_length') + 1,
      percent: this.presenter.getModelProperty('mortgage_funded.mortgages[0].term_progress')
    });
  };

  this._redrawLegal = function () {
    this._$node.find('.js--legal-disclaimer').mogo().redraw();
  };

  this.destroy = function () {
    this._super();
    this.presenter.removeComputedVariable('currentYear');
    this.presenter.removeComputedVariable('currentTerm');
    this.presenter.removeComputedVariable('lastCompleteTerm');
    this.presenter.removeComputedVariable('amoritization_month');
    this.presenter.removeComputedVariable('amoritization_year');
    this.presenter.removeComputedVariable('term_maturity_month');
    this.presenter.removeComputedVariable('term_maturity_year');
    this.presenter.removeComputedVariable('principal_paid');
  };

  this._applicationStarted = function () {
    return this.presenter.models.mortgage.type !== null;
  };

  this._applicationCompleted = function () {
    return this.presenter.models.mortgage.credit_check_consented_at !== null;
  };

  this._pushRatesAnalytics = function () {
    // rates analytics
    var $visibleRates = this._$rates.filter(':visible');
    if ($visibleRates.length) $visibleRates.mogo().pushAnalytics();
  };

  this._showProgressSteps = function () {
    this._$sectionContainer.addClass('section-container--second');
    this._scrollToTop();
    // update legal
    this._redrawLegal();

    // subview
    this._pushRatesAnalytics();
    this.analytics.pushEvent('virtual-page-view', { Page: [window.location.href + '/details'] });
    return false;
  };

  this._hideProgressSteps = function () {
    this._restoreDefaultView();
    this._scrollToTop();
    // update legal
    this._redrawLegal();

    // analytics
    this._pushRatesAnalytics();
    this.analytics.pushEvent('virtual-page-view');
    return false;
  };

  this._restoreDefaultView = function () {
    this._$sectionContainer.removeClass('section-container--second');
  };

  this._scrollToTop = function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  };
}